import { render } from "./NewAboutObject.vue?vue&type=template&id=4891b662&scoped=true"
import script from "./NewAboutObject.vue?vue&type=script&lang=js"
export * from "./NewAboutObject.vue?vue&type=script&lang=js"

import "./NewAboutObject.vue?vue&type=style&index=0&id=4891b662&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4891b662"]])

export default __exports__